import React, { useEffect, useState, useRef } from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import { Card, Button, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { listAwards, deleteAward } from '../actions/awardActions'

const placeholderImg = 'https://placehold.co/300x200?text=No+Image'

const isMp4 = (url) => url && url.toLowerCase().endsWith('.mp4')

function AwardListScreen() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [hoveredId, setHoveredId] = useState(null)
    const videoRefs = useRef({})
    const [mutedIds, setMutedIds] = useState(new Set())

    const awardList = useSelector(state => state.awardList)
    const { loading, error, awards } = awardList

    const awardDelete = useSelector(state => state.awardDelete)
    const { success: successDelete } = awardDelete

    const userLogin = useSelector(state => state.userLogin)
    const { userInfo } = userLogin

    useEffect(() => {
        if (!userInfo || !userInfo.isAdmin) {
            navigate('/login')
        } else {
            dispatch(listAwards())
        }
    }, [dispatch, navigate, userInfo, successDelete])

    const deleteHandler = (id) => {
        if (window.confirm('Delete this award?')) {
            dispatch(deleteAward(id))
        }
    }

    const toggleAudio = (id) => {
        const video = videoRefs.current[id]
        if (!video) return
        video.muted = !video.muted
        setMutedIds(prev => {
            const next = new Set(prev)
            video.muted ? next.add(id) : next.delete(id)
            return next
        })
    }

    return (
        <div>
            <Row className='align-items-center mb-4'>
                <Col><h2>Awards</h2></Col>
                <Col className='text-end'>
                    <LinkContainer to='/admin/awards/create'>
                        <Button variant='dark' size='sm'>
                            <i className='fa-solid fa-plus me-1'></i> Add Award
                        </Button>
                    </LinkContainer>
                </Col>
            </Row>

            {loading ? <Loader /> : error ? <Message variant='danger'>{error}</Message> : awards.length === 0 ? (
                <Message variant='info'>No records found. <LinkContainer to='/admin/awards/create'><a href='#'>Add one now.</a></LinkContainer></Message>
            ) : (
                <Row xs={2} sm={3} md={4} lg={5} className='g-3'>
                    {awards.map(award => (
                        <Col key={award.id}>
                            <Card
                                className='h-100'
                                style={{ cursor: 'default', position: 'relative', overflow: 'hidden' }}
                                onMouseEnter={() => setHoveredId(award.id)}
                                onMouseLeave={() => setHoveredId(null)}
                            >
                                {isMp4(award.image_mobile) ? (
                                    <video
                                        ref={el => { if (el) videoRefs.current[award.id] = el }}
                                        src={award.image_mobile}
                                        autoPlay
                                        loop
                                        playsInline
                                        style={{ width: '100%', height: '140px', objectFit: 'cover', display: 'block' }}
                                    />
                                ) : (
                                    <Card.Img
                                        variant='top'
                                        src={award.image_mobile || placeholderImg}
                                        alt={award.name}
                                        style={{ height: '140px', objectFit: 'cover' }}
                                    />
                                )}

                                {hoveredId === award.id && (
                                    <div style={{
                                        position: 'absolute', top: 0, left: 0,
                                        width: '100%', height: '140px',
                                        background: 'rgba(0,0,0,0.55)',
                                    }}>
                                        {isMp4(award.image_mobile) && (
                                            <Button
                                                variant='link'
                                                size='sm'
                                                onClick={() => toggleAudio(award.id)}
                                                style={{ position: 'absolute', top: '4px', right: '4px', color: 'white', padding: '2px 6px' }}
                                            >
                                                <i className={`fa-solid ${mutedIds.has(award.id) ? 'fa-volume-xmark' : 'fa-volume-high'}`}></i>
                                            </Button>
                                        )}
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', height: '100%' }}>
                                            <LinkContainer to={`/admin/awards/${award.id}/edit`}>
                                                <Button variant='light' size='sm'>
                                                    <i className='fa-solid fa-pen'></i>
                                                </Button>
                                            </LinkContainer>
                                            <Button variant='danger' size='sm' onClick={() => deleteHandler(award.id)}>
                                                <i className='fa-solid fa-trash'></i>
                                            </Button>
                                        </div>
                                    </div>
                                )}

                                <Card.Body className='p-2'>
                                    <Card.Title className='mb-1' style={{ fontSize: '0.9rem' }}>{award.name}</Card.Title>
                                    {award.description && (
                                        <Card.Text className='text-muted' style={{ fontSize: '0.75rem', marginBottom: 0 }}>
                                            {award.description}
                                        </Card.Text>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}
        </div>
    )
}

export default AwardListScreen
